module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-09.e2b21d56.png";